module.exports = __webpack_public_path__ + "img/Arthritis-01.e6f83cbe.svg";